<template>
  <div class="wrapper">
    <header>开票申请</header>
    <section>
      <div class="company">
        <!-- <p class="iconfont">&#xe614;</p> -->
        <p class="companyName">{{formData.companyName || ''}}</p>
      </div>
      <div class="form">
        <FormList
          v-if="formData.invoiceDimension === '0'"
          :list="formList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
        >
          <template slot="purchaserShowFlag">
            <van-checkbox :value="!!formData.purchaserShowFlag" icon-size="14px" shape="square" @click="changepurchaserShowFlag">是否展示</van-checkbox>
          </template>
        </FormList>
        <FormList
          v-if="formData.invoiceDimension === '1'"
          :list="orgList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
        />
        <div class="rollup" v-if="showTakerList && formalinvoiceList.length > 0">
          <div
            @click="onSelectCompany(item)"
            class="rollup-item"
            v-for="(item, index) in formalinvoiceList"
            :key="index"
          >
            <div class="rollup-company">
              <div>{{ item.name }}</div>
              <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
            </div>
          </div>
          <div
            @click="showTakerList = false"
            class="rollup-item"
          >
            <div class="rollup-company">
              <div>关闭</div>
            </div>
          </div>
        </div>
      </div>
      <Advertisement />
    </section>
    <footer>
      <van-button @click="submit" class="button">提交申请</van-button>
    </footer>
    <div class="pop-out" v-if="showApplyAgain">
      <div class="inside-wrp">
        <div>
        </div>
        <p>抬头提交成功</p>
        <div @click="clearInfo" class="button">再次提交</div>
        <div @click="closePage" class="button">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Checkbox, Button, Notify, Toast } from 'vant'
import FormList from '@components/FormList'
import { businessRequest } from '@services'
import {
  LOOK_UP_ORDER_INVOICE_TYPE
} from '@assets/config'
import { debounce, aesDoDecrypt, getQuery, isEmail, isSpecialTicket, autoMontageLookUp, removeSpace, CheckBusinessMainInfo } from '@/utils/basicUtil'
export default {
  components: {
    [Notify.name]: Notify,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Toast.name]: Toast,
    FormList
  },
  props: {},
  data () {
    return {
      formList: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: LOOK_UP_ORDER_INVOICE_TYPE
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头',
          required: true
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '请输入开票税号',
          label: '开票税号',
          required: true
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '填写购买方地址',
          label: '地址'
        },
        {
          type: 'text',
          field: 'purchaserTel',
          placeholder: '填写电话',
          label: '电话'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '填写开户行',
          label: '开户行'
        },
        {
          type: 'text',
          field: 'purchaserBankAccount',
          placeholder: '填写银行账号',
          label: '账号',
          slot: 'purchaserShowFlag'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '请输入手机号码',
          label: '手机号'
        }
        // {
        //   type: 'text',
        //   field: 'remark',
        //   placeholder: '请输入备注',
        //   label: '备注(选填)'
        // }
      ],
      orgList: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: LOOK_UP_ORDER_INVOICE_TYPE
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头',
          required: true
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '请输入开票税号',
          label: '开票税号'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '请输入手机号码',
          label: '手机号'
        }
      ],
      formData: {
        invoiceDimension: '0',
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserAddress: '',
        purchaserTel: '',
        purchaserBankName: '',
        purchaserBankAccount: '',
        purchaserEmail: '',
        purchaserPhone: '',
        remark: '',
        companyId: '',
        companyName: ''
      },
      formalinvoiceList: [],
      showTakerList: false,
      settlementInfo: {},
      showApplyAgain: false
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getOrderInfo()
  },
  activated () {},
  updated () {},
  methods: {
    changepurchaserShowFlag () {
      this.changeApply({
        purchaserShowFlag: this.formData.purchaserShowFlag ? 0 : 1
      })
    },
    getOrderInfo () {
      let { key } = getQuery()
      let info = aesDoDecrypt(key)
      this.formData.companyId = info.companyId
      this.formData.companyName = info.companyName
    },
    onInputChange ({ e, field }) {
      if (field === 'purchaserName') {
        if (this.formData.invoiceDimension !== '1') {
          this.showTakerList = true
          this.onSearch(e)
        }
      }
      if (field === 'purchaserTaxNo') {
        e = e ? e.toUpperCase() : e
      }
      if (field === 'invoiceDimension') {
        this.changeApply({
          purchaserName: '',
          purchaserTaxNo: '',
          purchaserAddress: '',
          purchaserTel: '',
          purchaserBankName: '',
          purchaserBankAccount: '',
          purchaserEmail: '',
          purchaserPhone: '',
          purchaserShowFlag: ''
        })
      }
      this.changeApply({
        [field]: removeSpace(e)
      })
    },
    changeApply (params) {
      this.formData = {
        ...this.formData,
        ...params
      }
    },
    onBlur ({ e, field }) {
      if (field === 'purchaserName') {
        this.testPurchaserName()
      } else if (field === 'purchaserTaxNo') {
        this.testPurchaserTaxNo()
      } else if (field === 'purchaserEmail') {
        // this.testPurchaserEmail()
      }
    },
    onFocus ({ e, field }) {
      if (field === 'purchaserName') {

      }
    },
    sliceStr (text, len) {
      if (text && text.length > len) {
        return text.slice(0, len) + '...'
      } else {
        return text
      }
    },
    debounce: debounce((vm) => { vm.getCustomerListByName() }, 300),
    onSearch (value) {
      if (value.length >= 1) {
        this.debounce(this)
      }
    },
    async getCustomerListByName () {
      if (!this.formData.purchaserName) {
        return
      }
      const data = await businessRequest.qrcode.getSmartTitle({ companyName: this.formData.purchaserName })
      if (data.success) {
        if (data.result.length) {
          this.formalinvoiceList = data.result
        } else {
          this.formalinvoiceList = []
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onSelectCompany (item) {
      const { address, bankName, bankNo, name, taxNo, tel } = autoMontageLookUp(item, 7)
      this.changeApply({
        purchaserName: name,
        purchaserTaxNo: taxNo ? taxNo.toUpperCase() : taxNo,
        purchaserAddress: `${address}`,
        purchaserBankName: `${bankName}`,
        purchaserTel: tel,
        purchaserBankAccount: bankNo
      })
      this.formalinvoiceList = []
    },
    async submit () {
      if (!this.testPurchaserName() || !this.testPurchaserTaxNo()) {
        return
      }
      // 校验购销方主体信息
      try {
        const check = new CheckBusinessMainInfo({})
        if (this.formData.invoiceDimension === '0') {
          check.purchaserName({ value: this.formData.purchaserName })
          check.purchaserTaxNo({ value: this.formData.purchaserTaxNo })
          // 不校验地址电话
          check.purchaserAddress({ value: this.formData.purchaserAddress, required: false })
          check.purchaserTel({ value: this.formData.purchaserTel, required: false })
          check.purchaserBankName({ value: this.formData.purchaserBankName, required: false })
          check.purchaserBankAccount({ value: this.formData.purchaserBankAccount, required: false })
        }
        check.remark({ value: this.formData.remark })
        check.purchaserPhone({ value: this.formData.purchaserPhone, required: false })
      } catch (error) {
        if (error.message) {
          Notify({ type: 'danger', message: error.message })
        }
        return
      }
      let params = {
        nature: this.formData.invoiceDimension,
        name: this.formData.purchaserName,

        tel: this.formData.purchaserTel,
        bankNo: this.formData.purchaserBankAccount,
        bankAccount: this.formData.purchaserBankAccount,
        taxNo: this.formData.purchaserTaxNo,
        address: `${this.formData.purchaserAddress}`,
        bankName: `${this.formData.purchaserBankName}`,
        email: this.formData.purchaserEmail,
        phone: this.formData.purchaserPhone,
        remark: this.formData.remark,
        companyId: this.formData.companyId
      }
      Toast.loading({
        message: '请求中...',
        forbidClick: true,
        duration: 0
      })
      const data = await businessRequest.qrcode.addWaitTitle({
        ...params,
        personLogo: this.formData.invoiceDimension === '1' ? 1 : 0,
        purchaserShowFlag: this.formData.purchaserShowFlag
      })
      if (data.success) {
        Toast.clear({
          clearAll: true
        })
        // Notify({ type: 'success', message: '保存成功' })
        this.showApplyAgain = true
      } else {
        Toast.clear({
          clearAll: true
        })
        Notify({ type: 'danger', message: data.result.message })
      }
    },
    testPurchaserName () {
      if (!this.formData.purchaserName) {
        Notify({ type: 'danger', message: '请填写开票抬头' })
        return false
      }
      return true
    },
    testPurchaserTaxNo () {
      if (this.formData.invoiceDimension === '0') {
        if (isSpecialTicket(this.settlementInfo.invoiceType)) {
          if (!this.formData.purchaserTaxNo.length) {
            Notify({ type: 'danger', message: '请填写开票税号' })
            return false
          }
          if (!/^[0-9A-Za-z]{9}$|^[0-9A-Za-z]{15}$|^[0-9A-Za-z]{17}$|^[0-9A-Za-z]{18}$|^[0-9A-Za-z]{19}$|^[0-9A-Za-z]{20}$/.test(this.formData.purchaserTaxNo.replace(/\s*/g, ''))) {
            Notify({ type: 'danger', message: '开票税号格式有误' })
            return false
          }
        } else {
          if (this.formData.purchaserTaxNo && (!/^[a-zA-Z0-9]+$/.test(this.formData.purchaserTaxNo) || this.formData.purchaserTaxNo.length > 20)) {
            Notify({ type: 'danger', message: '税号格式错误仅支持数字/字母，长度小于/等于20位' })
            return false
          }
        }
      }
      return true
    },
    testPurchaserEmail () {
      if (!this.formData.purchaserEmail) {
        Notify({ type: 'danger', message: '请填写邮箱' })
        return false
      }
      if (!isEmail(this.formData.purchaserEmail)) {
        Notify({ type: 'danger', message: '邮箱格式有误' })
        return false
      }
      return true
    },
    clearInfo () {
      this.changeApply({
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserAddress: '',
        purchaserTel: '',
        purchaserBankName: '',
        purchaserBankAccount: '',
        purchaserEmail: '',
        purchaserPhone: ''
      })
      this.showApplyAgain = false
    },
    closePage () {
      if (window.WeixinJSBridge) {
        window.WeixinJSBridge.call('closeWindow')
      } else {
        this.clearInfo()
      }
    }
  }
}
</script>
<style lang="less" scoped src="./index.less"/>
